import type { FC } from 'react'

import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import type { Course } from '@segment/api/routes/academy/types'

import CourseSection from './CourseSection'

interface AvailableCoursesProps {
  courses: Course[]
}

const copy = {
  heading: `Available Courses`,
}

const AvailableCourses: FC<AvailableCoursesProps> = ({ courses }) => {
  return (
    <StyledSection variant="noCopy" sticky={true}>
      <Section.Contents>
        <StyledCopyText>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
        </StyledCopyText>
        {courses.map((course) => (
          <CourseSection key={course.courseNumber} course={course} />
        ))}
      </Section.Contents>
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  & > ${Section.Wrapper} {
    padding-left: 0;
    padding-right: 0;
  }
`

const StyledCopyText = styled(CopyTextBase)`
  padding: 0 24px;

  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    padding: 0 40px;
  }

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding: 0 80px;
  }
`

export default AvailableCourses
